// Naive implementation - in reality would want to attach
// a window or resize listener. Also use state/layoutEffect instead of ref/effect
// if this is important to know on initial client render.
// It would be safer to  return null for unmeasured states.
const htmlDecode = (html) => {
  var txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
};

export default htmlDecode;